<div [ngClass]="class" class="dashboard-portal" #portlet>
  <ng-content></ng-content>
</div>